// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Success renders the component 1`] = `
.c3 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  font-size: 1.75rem;
  line-height: 120%;
}

.c4 {
  font-weight: 500;
  padding: 0;
  margin: 0;
  color: #737482;
  font-size: 0.875rem;
  line-height: 140%;
}

.c0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c2 {
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #11bc6e;
  color: #fff;
  width: 3.75rem;
  min-width: 3.75rem;
  height: 3.75rem;
  min-height: 3.75rem;
  border-radius: 50%;
}

.c1 {
  width: 560px;
  background-color: #fff;
  padding: 50px 40px;
}

.c5 {
  cursor: pointer;
  background-color: transparent;
  -webkit-align-items: baseline;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  border: 1px solid transparent;
  border-radius: 2px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  -webkit-transition: none;
  transition: none;
  font-size: 0.875rem;
}

.c5:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}

<div>
  <div
    class="c0 c1"
  >
    <div
      class="c2"
      color="success"
    >
      <svg
        aria-label="envelope badge"
        color="currentColor"
        fill="none"
        focusable="false"
        height="32"
        role="img"
        viewBox="0 0 32 32"
        width="32"
      >
        <path
          clip-rule="evenodd"
          d="M0 5a1 1 0 011-1h30a1 1 0 011 1v17a1 1 0 11-2 0V7.19L16.655 18.756a1 1 0 01-1.31 0L2 7.19V26h29a1 1 0 110 2H1a1 1 0 01-1-1V5zm3.68 1h24.64L16 16.677 3.68 6z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
    </div>
    <h2
      class="c3"
      style="text-align: center; margin: 20px 0px 0px; padding: 0px;"
    >
      Your Account has Been Created
    </h2>
    <p
      class="c4"
      font-weight="500"
      style="text-align: center; margin-bottom: 20px;"
    >
      We’ve sent a confirmation email to
       
      <span
        style="font-weight: 600;"
      >
        email@email.com
      </span>
      .
      <br />
      Please check your inbox and click the confirmation link to complete your registration.
      <br />
      If you don’t see the email, check your spam or junk folder.
    </p>
    <div>
      <a
        class="c5"
        href="/login"
        variant="normal"
      >
        Go to Log In
      </a>
    </div>
  </div>
</div>
`;
